import { useSessionTimeoutStore } from '@/stores/session-timeout.store';

/**
 * Session-timeout hook exposing reactive warning/time-remaining state plus
 * actions, mirroring the Angular SessionTimeoutService surface.
 */
export function useSessionTimeout() {
  const showWarning = useSessionTimeoutStore((s) => s.showWarning);
  const timeRemaining = useSessionTimeoutStore((s) => s.timeRemaining);

  const startMonitoring = useSessionTimeoutStore((s) => s.startMonitoring);
  const stopMonitoring = useSessionTimeoutStore((s) => s.stopMonitoring);
  const resetActivity = useSessionTimeoutStore((s) => s.resetActivity);
  const extendSession = useSessionTimeoutStore((s) => s.extendSession);
  const setLogoutHandler = useSessionTimeoutStore((s) => s.setLogoutHandler);

  return {
    showWarning,
    timeRemaining,
    startMonitoring,
    stopMonitoring,
    resetActivity,
    extendSession,
    setLogoutHandler,
  };
}
